export const GET_LATEST_MOVIES = "GET_LATEST_MOVIES"; // latest moves
export const GET_LATEST_SERIES = "GET_LATEST_SERIES"; // latest series
export const GET_RELATED_MOVIES = "GET_RELATED_MOVIES"; // related movies
export const GET_HOME_HERO_MOVIES = "GET_HOME_HERO_MOVIES"; // main page movie slider
